import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '~spa/Components/Link/Link';

import './widget-quick-links.scss';

const BASE_CLASS = 'widget-quick-links';

const WidgetQuickLink = ({
    data,
    sportSlug,
}) => {

    if (!data.length) {
        return null;
    }

    return (
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__container`}>
                {
                    data.map(({ id, label, url }) => (
                        <Link
                            key={id}
                            to={url}
                            gtmAttribute={`${sportSlug}-widget-quick-link;${label}`}
                            className={`${BASE_CLASS}__link`}>
                                <span className={`${BASE_CLASS}__link-label`}>{label}</span>
                        </Link>
                    ))
                }
            </div>
        </div>
    );
};

WidgetQuickLink.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    sportSlug: PropTypes.string.isRequired,
};

WidgetQuickLink.defaultProps = {
    data: [],
};

export default WidgetQuickLink;
